import type { UserConfig } from 'i18next-parser'
import deTranslation from './src/i18n/resources/de/shared.json'
import devTranslation from './src/i18n/resources/dev/shared.json'
import enTranslation from './src/i18n/resources/en/shared.json'
import itTranslation from './src/i18n/resources/it/shared.json'

export const StaticSharedI18nResources = {
  resources: {
    en: enTranslation,
    dev: devTranslation,
    de: deTranslation,
    it: itTranslation,
  },
  namespace: 'shared' as const,
} as const

export const baseConfig: UserConfig = {
  output: './src/i18n/resources/$LOCALE/$NAMESPACE.json',
  locales: ['dev', 'de', 'en'],
  pluralSeparator: '_',
  defaultValue: (locale?: string, _namespace?: string, _key?: string, value?: string) => {
    if (locale === 'dev') {
      return value ?? ''
    }
    return ''
  },

  indentation: 2,
  sort: true,
  failOnWarnings: true,
  verbose: false,
  i18nextOptions: {
    // required to generate plural forms
    compatibilityJSON: 'v3',
    // simplifyPluralSuffix: false
  },
  keepRemoved: [/_(zero|one|two|few|many|other)$/], // keep all plural forms
}

/**
 * DO NOT USE THIS CONFIGURATION.
 * Use `import { baseConfig } from 'i18next-parser.config` instead to avoid introducing breaking changes
 */
// biome-ignore lint/style/noDefaultExport: i18n parser expects a default export
export default {
  ...baseConfig,
  defaultNamespace: 'shared',
} satisfies UserConfig
